import {
  Link,
} from '@cloudscape-design/components';
import { PartsTabs } from '@parallel-fluidics/shared/constants';
import { useTrackersData } from 'pages/Trackers/trackersProvider';
import PropTypes from 'prop-types';
import { useUserData } from 'providers/userDataProvider';
import React, { forwardRef } from 'react';
import { stepType } from 'utils/reactFlowUtils';

import AddTravelers from './addTravelers';
import Arrow from './arrow';
import Flowchart from './flowchart';
import SelectionProvider from './selectionProvider';
import ShippingDate from './shippingDate';

const ExpandedFlowchartView = forwardRef(({
  treesData,
  root,
  collapse,
}, ref) => {
  if (treesData?.length > 0) {
    return (
      <SelectionProvider root={root}>
        <div ref={ref} className="expandedView">
          <FinalListItems projectId={root.projectId} />
          <Flowchart
            type="expanded"
            treesData={treesData}
            root={root}
          />
          <button
            type="button"
            className="collapse"
            onClick={collapse}
          >
            <Arrow expanded />
            <span>Collapse</span>
          </button>
        </div>
      </SelectionProvider>
    );
  }
  return (
    <p className="emptyCollapsedView">No steps</p>
  );
});

ExpandedFlowchartView.propTypes = {
  treesData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.arrayOf(stepType),
    ),
  ).isRequired,
  root: stepType.isRequired,
  collapse: PropTypes.func.isRequired,
};

export default ExpandedFlowchartView;

function FinalListItems({ projectId }) {
  const { user: { canEditOrder } } = useUserData();
  const { groupedOrdersByProject } = useTrackersData();
  const { lineItemsMap, projectDocId } = groupedOrdersByProject[projectId];

  return (
    <div className="finalListItems">
      {Object.keys(lineItemsMap)?.length > 0
        ? (
          <>
            <h3>Final line items</h3>
            <ul>
              {Object.values(lineItemsMap).map((lineItem, lineItemIdx) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`${lineItem.lineItemId}-${lineItemIdx}`} className={canEditOrder ? 'withLink' : undefined}>
                  <div className="badgeContainer">
                    <p className="badge finalLineItem">
                      {lineItem.pPartId || lineItem.lineItemId}
                    </p>
                    {lineItem.canAddTravelers && (
                      <AddTravelers lineItemData={lineItem} />
                    )}
                    {canEditOrder ? (
                      <Link color="inverted" variant="info" external href={`/orders/update/${lineItem.lineItemId.split('_')[1]}#item_${lineItem.lineItemId.split('_').slice(-2).join('_')}`} />
                    ) : (
                      <Link color="inverted" variant="info" external href={`/projects/${projectDocId}?partDisplay=${PartsTabs.FLOW}`} />
                    )}
                  </div>
                  <p className={`notes${lineItem.notes?.length <= 0 ? ' empty' : ''}`}>
                    {lineItem.notes?.length <= 0 ? 'No notes.' : lineItem.notes}
                  </p>
                  <ShippingDate
                    numParts={lineItem.goal}
                    shipDateTarget={lineItem.shipDateTarget}
                    shipDateActual={lineItem.shipDateActual}
                    shipDateBusinessDays={lineItem.shipDateBusinessDays}
                    isInternal={projectId.startsWith('P')}
                  />
                </li>
              ))}
            </ul>
          </>
        ) : (
          <h3 className="empty">No final line items</h3>
        )}
    </div>
  );
}

FinalListItems.propTypes = {
  projectId: PropTypes.string.isRequired,
};
